import { render, staticRenderFns } from "./GenerationHistoryDetailView.vue?vue&type=template&id=4e315f8b"
import script from "./GenerationHistoryDetailView.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports